import React from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useDrawerContext } from './DrawerContext';

const DeliveryZipCode = React.lazy(() => import(
  /* webpackChunkName: "DeliveryZipCode" */
  '@thd-olt-component-react/delivery-zip-code')
  .then(module => ({ default: module.DeliveryZipCode }))
// eslint-disable-next-line no-console
  .catch((error) => console.warn(`Error occurred while lazy loading delivery zip code - ${error}`)));

const DeliveryZipCodeContent = () => {
  const { drawerState, drawerDispatch } = useDrawerContext();
  const { isUpdating } = drawerState;
  const setIsUpdating = (payload) => {
    drawerDispatch({ type: 'SET_IS_UPDATING', payload });
  };
  return (
    <ErrorBoundary id="header-delivery-zip-code" name="header-delivery-zip-code">
      <DeliveryZipCode isUpdating={isUpdating} setIsUpdating={setIsUpdating} />
    </ErrorBoundary>
  );
};

DeliveryZipCodeContent.displayName = 'DeliveryZipCodeContent';

export default DeliveryZipCodeContent;